import React from 'react';
import Header from '../components/Header';
import Galerija from '../components/Galerija';
import Footer from '../components/Footer';

function GalerijaPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <Galerija />
      </div>
      <Footer />
    </>
  );
}

export default GalerijaPage;
